/** `/api/favorites/:id/*` 客户端（M5 起）。 */

import { apiGet, apiSend } from "./client";

export interface Me {
  open_id: string;
  name: string | null;
  avatar_url: string | null;
  is_admin: boolean;
}

export function getMe(): Promise<Me> {
  return apiGet<Me>("/api/auth/me");
}

export interface ForwardPayload {
  target_type: "chat";
  target_id: string;
  thread_id?: string;
}

export interface ForwardResult {
  message_id: string;
}

export function forwardFavorite(
  favoriteId: number,
  payload: ForwardPayload,
): Promise<ForwardResult> {
  return apiSend<ForwardResult>(
    `/api/favorites/${favoriteId}/forward`,
    "POST",
    payload,
  );
}

export interface SavePayload {
  message_id: string;
  chat_id?: string;
}

export interface SaveResult {
  success: boolean;
  already_exists?: boolean;
}

export function saveFavorite(payload: SavePayload): Promise<SaveResult> {
  return apiSend<SaveResult>("/api/favorites/save", "POST", payload);
}

export interface SaveFromSdkPayload {
  message_id: string;
  msg_type: string;
  content: Record<string, unknown>;
  content_text: string;
  chat_id?: string;
  sender_open_id?: string;
  sender_name?: string;
}

export function saveFavoriteFromSdk(payload: SaveFromSdkPayload): Promise<SaveResult> {
  return apiSend<SaveResult>("/api/favorites/save_from_sdk", "POST", payload);
}

export function updateFavorite(
  favoriteId: number,
  payload: { title?: string | null },
): Promise<void> {
  return apiSend<void>(`/api/favorites/${favoriteId}`, "PATCH", payload);
}

export interface CheckThreadResult {
  is_thread: boolean;
  thread_id?: string;
}

export function checkMessageThread(openMessageId: string): Promise<CheckThreadResult> {
  return apiSend<CheckThreadResult>("/api/messages/check_thread", "POST", {
    open_message_id: openMessageId,
  });
}
